module.exports = __webpack_public_path__ + "img/proImg4.aac5ac53.png";